import React from 'react';
import { BrowserRouter, Route, Switch, Redirect } from 'react-router-dom';
import EventsList from '../containers/EventsList';
import CreateEvent from '../containers/CreateEvent';
import ViewEvent from '../containers/ViewEvent';
import ModifyEvent from '../containers/ModifyEvent';
import NotFoundPage from '../components/NotFoundPage';
import ForbiddenPage from '../components/ForbiddenPage';
import withClone from '../containers/ModifyEvent/hoc/withClone';
import withEdit from '../containers/ModifyEvent/hoc/withEdit';

const AppNavigator = () => {
  return (
    <BrowserRouter>
      <Switch>
        <Route path="/" render={() => <Redirect to="/events" />} exact />
        <Route path="/events" component={EventsList} exact />
        <Route path="/create" component={CreateEvent} exact />
        <Route path="/events/:id" component={ViewEvent} exact />
        <Route path="/events/:id/edit" component={withEdit(ModifyEvent)} />
        <Route path="/events/:id/clone" component={withClone(ModifyEvent)} />
        <Route path="/403" component={ForbiddenPage} />
        <Route path="*" component={NotFoundPage} />
      </Switch>
    </BrowserRouter>
  );
};

export default AppNavigator;
